import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './DropMenu.css'

export const DropMenu = ({ children, links, navClick }) => {
    const [active, setActive] = useState(false);
    const navigate = useNavigate();

    // Function to handle a click of DropMenu component and to open it by setting it to "active".

    const handleClick = () => {
        setActive(!active)
    };

    // Links flagged as internal route within the app; everything else opens externally.

    const handleLink = (l) => {
        setActive(false);
        if (l.internal) {
            navigate(l.url)
        } else {
            navClick(l.url)
        };
    };

    const dropLinks = links.map((l) => {
      return (
        <p className="drop-link" onClick={() => handleLink(l)} key={l.name}>{l.name}</p>
      )
    });

    // Clicking on DropMenu will add an "active" class which through CSS will render the links provided to the DropMenu Component.

  return (
    <div className={"drop-container " + (active ? "active" : "")}>
        <p className="nav-link" onClick={handleClick}>{active ? (children + "⌵") : (children + "⌃")}</p>
        <div className="drop-links">
          {dropLinks}
        </div>
    </div>
  );
};